<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="grid_row" v-else>
      <v-form ref="update" @submit.prevent="update_po">
        <v-card elevation="6">
          <div class="pa-2">
            <v-slide-x-reverse-transition>
              <v-alert
                type="success"
                class="alert"
                v-if="alert_success === true"
                >เพิ่มข้อมูลเรียบร้อย !</v-alert
              >
              <v-alert type="error" class="alert" v-if="alert_danger === true"
                >ลบข้อมูลเรียบร้อย !</v-alert
              >
            </v-slide-x-reverse-transition>
          </div>
          <div class="grid_half">
            <div class="grid_list pa-4">
              <div class="mr-1">
                <div>เลขที่/PO No.</div>
                <div class="pl-3 pt-1 grey--text">
                  {{ product_list[0].po_code }}
                </div>
              </div>
              <div class="mt-3 mr-1">
                <v-text-field
                  color="#86bc3a"
                  label="เลขที่ใบเสร็จ"
                  prepend-inner-icon="mdi-file-compare"
                  :rules="[(v) => !!v || 'กรุณากรอกเลขที่ใบเสร็จ']"
                  v-model="header_list.receipt_no"
                  hide-details="auto"
                  outlined
                ></v-text-field>
              </div>
              <div class="mr-1">
                <div>ชื่อบริษัท/Supplier Name</div>
                <div class="pl-3 pt-1 grey--text">
                  {{ product_list[0].name_suppliers }}
                </div>
              </div>
              <div class="mt-3">
                <div class="mr-1">
                  <v-menu
                    ref="menu_date"
                    v-model="menu_date"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        color="#86bc3a"
                        v-model="date"
                        label="วันที่ใบเสร็จ (วัน/เดือน/ปี)"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="TH"
                      color="#86bc3a"
                      @change="diffDate_TH(dateEN)"
                      v-model="dateEN"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="selectDate()">
                        ตกลง
                      </v-btn>
                      <v-btn text color="primary" @click="menu_date = false">
                        ยกเลิก
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>
            </div>
            <div class="ma-4">
              <div class="grid_vat">
                <div class="ml-1">
                  <div>ภาษีการซื้อ :</div>
                </div>
                <div class="mt-3 mr-1">
                  <v-radio-group v-model="header_list.vat_type" mandatory>
                    <div class="d-flex justify-space-around">
                      <div class="d-flex ml-5">
                        <div>
                          <v-radio color="#86bc3a" :value="0"></v-radio>
                        </div>
                        <div>ภาษีรวมใน</div>
                      </div>
                      <div class="d-flex">
                        <div>
                          <v-radio color="#86bc3a" :value="1"></v-radio>
                        </div>
                        <div>ภาษีแยกนอก</div>
                      </div>
                    </div>
                    <div class="d-flex justify-space-around mt-6">
                      <div class="d-flex" style="margin-left: 3px">
                        <div>
                          <v-radio color="#86bc3a" :value="2"></v-radio>
                        </div>
                        <div>ไม่กระทบภาษี</div>
                      </div>
                      <div class="d-flex ml-n12">
                        <div>
                          <v-radio color="#86bc3a" :value="3"></v-radio>
                        </div>
                        <div>ภาษีเป็น 0</div>
                      </div>
                    </div>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </div>
          <div class="grid_half">
            <div v-if="header_list.is_credit === 1">
              <div class="grid_list pa-4">
                <div class="mt-5 mr-1">
                  <v-menu
                    ref="menu_due_date"
                    v-model="menu_due_date"
                    :close-on-content-click="false"
                    :return-value.sync="dateDue"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        color="#86bc3a"
                        v-model="dateDue"
                        label="วันที่ครบกำหนด (วัน/เดือน/ปี)"
                        :rules="[(v) => !!v || 'กรุณากรอกวันที่ครบกำหนด']"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="TH"
                      color="#86bc3a"
                      @change="diffDueDate_TH(dateDueEN)"
                      v-model="dateDueEN"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="selectDueDate()">
                        ตกลง
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_due_date = false"
                      >
                        ยกเลิก
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>
            </div>
            <div v-else></div>
            <div class="ma-4">
              <div class="grid_vat">
                <div class="ml-1">
                  <div>ประเภท :</div>
                </div>
                <div class="mt-3 mr-1">
                  <v-radio-group v-model="header_list.is_credit" mandatory>
                    <div class="d-flex justify-space-around">
                      <div class="d-flex ml-n4">
                        <div>
                          <v-radio color="#86bc3a" :value="0"></v-radio>
                        </div>
                        <div>เงินสด</div>
                      </div>
                      <div class="d-flex ml-n12">
                        <div>
                          <v-radio color="#86bc3a" :value="1"></v-radio>
                        </div>
                        <div>เครดิต</div>
                      </div>
                    </div>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </div>
          <div class="grid_full">
            <div class="grid_product pa-4">
              <div style="display: flex; !important;">
                <v-autocomplete
                  color="#86bc3a"
                  clearable
                  :items="product_list_supplier"
                  item-text="name"
                  item-value="product_id"
                  v-model="pro_id"
                  prepend-inner-icon="mdi-flask-plus-outline"
                  label="สินค้า"
                  hide-details="auto"
                  outlined
                ></v-autocomplete>
                <v-btn
                  v-if="pro_id !== null"
                  class="ml-2 pa-7 mr-4 grad-success-bg white--text"
                  @click="add_product(pro_id)"
                  style="width: 30%"
                  >เพิ่มสินค้า</v-btn
                >
                <v-btn
                  v-if="pro_id === null"
                  class="ml-2 pa-7 mr-4 grad-grey-bg"
                  style="width: 30%"
                  disabled
                  >เพิ่มสินค้า</v-btn
                >
              </div>
            </div>
          </div>
          <v-card-title>
            <v-text-field
              v-model="search"
              color="#86bc3a"
              append-icon="mdi-magnify"
              label="ค้นหา"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <div class="pa-2">
            <v-data-table
              class="mb-2"
              :headers="Po_List"
              :items="data_list"
              key="index"
              item-key="product_code"
              :search="search"
              mobile-breakpoint="0"
              hide-default-footer
              :items-per-page="100"
            >
              <template slot="item" slot-scope="dataDetail">
                <tr>
                  <td>{{ dataDetail.index + 1 }}</td>
                  <td>{{ dataDetail.item.product_code }}</td>
                  <td class="pa-3">
                    <v-text-field
                      color="#86bc3a"
                      label="ล็อต"
                      :rules="[(v) => !!v || 'กรุณากรอกล็อต']"
                      hide-details="auto"
                      v-model="dataDetail.item.lot_no"
                      outlined
                    ></v-text-field>
                  </td>
                  <td>{{ dataDetail.item.product_name }}</td>
                  <td>
                    <!-- {{ dataDetail.item }} -->
                    <v-select
                      v-if="dataDetail.item.po_id === null"
                      color="#86bc3a"
                      :items="dataDetail.item.units"
                      placeholder="กรุณาเลือก"
                      :rules="[(v) => !!v || 'กรุณาเลือก']"
                      item-text="unit_name"
                      item-value="unit_id"
                      hide-details="auto"
                      v-model="dataDetail.item.unit_id"
                      outlined
                    />
                    <div v-else class="">{{ dataDetail.item.unit_name }}</div>
                  </td>
                  <td>
                    <!-- :disabled-date="notBeforeToday" -->
                    <date-picker
                      clearable
                      class="input_style"
                      value-type="format"
                      :formatter="format"
                      v-model="dataDetail.item.date_exp"
                      :placeholder="dataDetail.item.date_exp"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-if="dataDetail.item.po_id === null"
                      color="#86bc3a"
                      type="number"
                      @keypress="isOnlyNumber($event)"
                      label="จำนวนที่ได้รับ"
                      :rules="[(v) => !!v || 'กรุณากรอกจำนวนที่ได้รับ']"
                      hide-details="auto"
                      min="0"
                      v-model="dataDetail.item.qty_received"
                      outlined
                    ></v-text-field>
                    <div v-else class="text-center">
                      {{ dataDetail.item.qty_received }}
                    </div>
                  </td>
                  <td>
                    <v-text-field
                      color="#86bc3a"
                      type="number"
                      @keypress="isCurrency($event, dataDetail.item.price)"
                      label="ราคาต่อหน่วย"
                      :rules="[(v) => !!v || 'กรุณากรอกราคาต่อหน่วย']"
                      hide-details="auto"
                      min="0"
                      v-model="dataDetail.item.price"
                      outlined
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      color="#86bc3a"
                      type="number"
                      @keypress="
                        isCurrency($event, dataDetail.item.discount_unit_price)
                      "
                      label="ส่วนลด(บาท)"
                      hide-details="auto"
                      min="0"
                      v-model="dataDetail.item.discount_unit_price"
                      outlined
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      color="#86bc3a"
                      type="number"
                      @keypress="
                        isCurrency(
                          $event,
                          dataDetail.item.discount_unit_percent
                        )
                      "
                      label="ส่วนลด(%)"
                      hide-details="auto"
                      min="0"
                      v-model="dataDetail.item.discount_unit_percent"
                      outlined
                    ></v-text-field>
                  </td>
                  <td>
                    {{
                      format_price(
                        (dataDetail.item.total =
                          (dataDetail.item.price -
                            (dataDetail.item.price *
                              dataDetail.item.discount_unit_percent) /
                              100) *
                            dataDetail.item.qty_received -
                          dataDetail.item.discount_unit_price)
                      )
                    }}
                  </td>
                  <td>
                    <!-- ค่าเก่าที่มีอยู่แล้ว -->
                    <div
                      v-if="
                        dataDetail.item.status_return_old == 1 &&
                        dataDetail.item.status_return == 0
                      "
                    >
                      -
                    </div>
                    <div
                      v-if="
                        dataDetail.item.status_return_old == 1 &&
                        dataDetail.item.status_return == 1
                      "
                    >
                      รอคืน
                    </div>
                    <!-- ค่าใหม่ที่พึ่งมา -->
                    <div v-if="dataDetail.item.status_return_old == 0">
                      <v-checkbox
                        color="#86bc3a"
                        v-model="dataDetail.item.status_return"
                      />
                    </div>
                  </td>
                  <td class="pa-3">
                    <div
                      class="text-center"
                      v-if="dataDetail.item.po_id !== null"
                    >
                      -
                    </div>
                    <v-btn
                      v-else
                      small
                      height="42"
                      @click="getDelete(dataDetail.item.loop_id)"
                      class="grad-danger-bg white--text mb-1"
                    >
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-slot:body.append>
                <tr>
                  <td colspan="8" class="pa-2 border_col">
                    <div class="ma-4">
                      <div class="text-center">รวม</div>
                    </div>
                  </td>
                  <td colspan="5" class="pa-2 border_col">
                    <div class="ma-4">
                      <div class="text-center">
                        {{ (header_list.sub_total = total) }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="8" class="pa-2 border_col"></td>
                  <td colspan="2" class="pa-2 border_col">
                    <div class="ma-4">
                      <div>ส่วนลดท้ายบิล (%)</div>
                    </div>
                  </td>
                  <td colspan="3" class="pa-2 border_col">
                    <div class="ma-4">
                      <div>
                        <v-text-field
                          color="#86bc3a"
                          type="number"
                          label="ส่วนลดท้ายบิล (%)"
                          @keypress="
                            isCurrency($event, header_list.discount_percent)
                          "
                          hide-details="auto"
                          min="0"
                          v-model="header_list.discount_percent"
                          outlined
                        ></v-text-field>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="8" class="pa-2 border_col"></td>
                  <td colspan="2" class="pa-2 border_col">
                    <div class="ma-4">
                      <div>ส่วนลดท้ายบิล (หน่วย)</div>
                    </div>
                  </td>
                  <td colspan="3" class="pa-2 border_col">
                    <div class="ma-4">
                      <div>
                        <v-text-field
                          color="#86bc3a"
                          type="number"
                          label="ส่วนลดท้ายบิล (หน่วย)"
                          @keypress="isCurrency($event, header_list.discount)"
                          hide-details="auto"
                          min="0"
                          v-model="header_list.discount"
                          outlined
                        ></v-text-field>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="8" class="pa-2 border_col"></td>
                  <td colspan="2" class="border_col">
                    <div class="ml-2 mb-7">ราคาสินค้าไม่รวมภาษี</div>
                    <div class="ml-2 pt-1">ภาษีมูลค่าเพิ่ม 7%</div>
                  </td>
                  <td colspan="3" class="pa-2 border_col">
                    <div class="ma-4 text-center">
                      {{ (product_no_vat = no_vat) }}
                    </div>
                    <v-divider />
                    <div class="ma-4 text-center">
                      {{ (product_add_vat = cal_vat) }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="8" class="pa-2 border_col"></td>
                  <td colspan="2" class="pa-2 border_col">
                    <div class="ma-4">
                      <div>จำนวนเงินทั้งสิ้นรวมภาษี</div>
                    </div>
                  </td>
                  <td colspan="3" class="pa-2 border_col">
                    <div class="ma-4">
                      <!-- <div class="text-center">{{ format_price(header_list.grand_total = (total_all - header_list.discount)) }}</div> -->
                      <div class="text-center">
                        {{ (header_list.grand_total = total_all) }}
                      </div>
                    </div>
                  </td>
                </tr>
                <v-divider />
              </template>
            </v-data-table>
            <div class="pa-4">
              <div class="mb-4">หมายเหตุ</div>
              <v-textarea
                v-if="header_list.note != null"
                color="#86bc3a"
                label="กรุณากรอกหมายเหตุ"
                v-model="header_list.note"
                outlined
              ></v-textarea>
              <v-textarea
                v-if="header_list.note == null"
                color="#86bc3a"
                label="กรุณากรอกหมายเหตุ"
                v-model="header_list.note"
                value="-"
                outlined
              ></v-textarea>
            </div>
          </div>
          <div class="pa-6 text-right">
            <v-btn
              x-large
              type="submit"
              class="grad-warning-bg white--text"
              style="font-size: 18px"
              >แก้ไขข้อมูล</v-btn
            >
          </div>
        </v-card>
      </v-form>
    </div>
    <v-overlay :value="overlay" class="z_index">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          size="70"
          width="7"
          color="#86bc3a"
        ></v-progress-circular>
        <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import {
  diffChangeFormat_2,
  formatPrice,
  minDate,
  onlyForCurrency,
  onlyForNumber,
} from "@/js/handler";
import { HTTP } from "@/axios";
import Swal from "sweetalert2";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: {
    DatePicker,
  },
  name: "StoragePO_edit",
  data() {
    return {
      search: "",
      date: "",
      dateEN: "",
      dateDue: "",
      overlay: false,
      dateDueEN: "",
      pro_id: null,
      menu_date: false,
      menu_due_date: false,
      loading_page: false,
      alert_success: false,
      alert_danger: false,
      format: {
        stringify: (date) => {
          const date_moment = moment(date).format("DD-MM-YYYY");
          const diff = date_moment.split("-");
          const day = diff[0];
          const month = diff[1];
          const year = parseInt(diff[2]);
          return day + "-" + month + "-" + year;
        },
      },
      discount_final: 0,
      product_no_vat: 0,
      product_add_vat: 0,
      Po_List: [
        {
          text: "ลำดับ",
          value: "index",
          fixed: true,
          width: "100px",
        },
        {
          text: "รหัสสินค้า",
          value: "product_code",
          fixed: true,
          width: "125px",
        },
        {
          text: "ล็อต",
          value: "product_lot",
          fixed: true,
          width: "170px",
        },
        {
          text: "รายการสินค้า",
          value: "product_name",
          fixed: true,
          width: "250px",
        },
        {
          text: "หน่วยนับ",
          value: "units",
          fixed: true,
          width: "180px",
        },
        {
          text: "วันที่หมดอายุ",
          value: "date_exp",
          fixed: true,
          width: "200px",
        },
        {
          text: "จำนวนที่ได้รับ",
          value: "qty_received",
          fixed: true,
          width: "150px",
        },
        {
          text: "ราคาต่อหน่วย",
          value: "price",
          fixed: true,
          width: "150px",
        },
        {
          text: "ส่วนลด(บาท)",
          value: "discount_unit",
          fixed: true,
          width: "150px",
        },
        {
          text: "ส่วนลด(%)",
          value: "discount",
          fixed: true,
          width: "150px",
        },
        {
          text: "ราคารวม",
          value: "total",
          sortable: false,
          fixed: true,
          width: "100px",
        },
        {
          text: "สินค้ารอคืน",
          value: "status_return",
          sortable: false,
          fixed: true,
          width: "120px",
        },
        {
          text: "ลบ",
          value: "action",
          sortable: false,
          fixed: true,
          width: "50px",
        },
      ],
      header_list: [],
      data_list: [],
      product_list: [],
      product_list_supplier: [],
      unit_list: [],
      loop_id: 0,
    };
  },
  methods: {
    async selectDate() {
      this.$refs.menu_date.save(this.date);
      this.menu_date = false;
    },
    async selectDueDate() {
      this.$refs.menu_due_date.save(this.dateDue);
      this.menu_due_date = false;
    },
    date_table(value) {
      const diff = value.split("-");
      const day = diff[2];
      const month = diff[1];
      const year = parseInt(diff[0]);
      return day + "-" + month + "-" + year;
    },
    diffDate_TH(value) {
      const diff = value.split("-");
      const day = diff[2];
      const month = diff[1];
      const year = parseInt(diff[0]) + 543;
      const final_date = day + "-" + month + "-" + year;
      return (this.date = final_date);
    },
    diffDateEN() {
      const diff = this.date.split("-");
      const year = parseInt(diff[2]) - 543;
      const month = diff[1];
      const day = diff[0];
      return year + "-" + month + "-" + day;
    },
    diffDueDate_TH(value) {
      if (value !== null && value !== "") {
        const diff = value.split("-");
        const day = diff[2];
        const month = diff[1];
        const year = parseInt(diff[0]) + 543;
        const final_date = day + "-" + month + "-" + year;
        return (this.dateDue = final_date);
      } else {
        this.dateDue = "";
        return this.dateDue;
      }
    },
    diffDueDateEN() {
      if (this.dateDue !== null && this.dateDue !== "") {
        const diff = this.dateDue.split("-");
        const year = parseInt(diff[2]) - 543;
        const month = diff[1];
        const day = diff[0];
        return year + "-" + month + "-" + day;
      }
    },
    format_price: function (value) {
      return formatPrice(value);
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt);
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number);
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    min_date: function () {
      return minDate();
    },
    diffDate_Change_2: function (value) {
      return diffChangeFormat_2(value);
    },
    get_data() {
      this.data_list = [];
      this.loading_page = true;
      HTTP.post("/imports/po/editpo", {
        po_id: this.$route.params.id,
        import_id: this.$route.params.import,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false;
          this.header_list = res.data.object.import_products_header;
          if (res.data.object.import_products_header.receipt_date !== null) {
            this.date = res.data.object.import_products_header.receipt_date;
            this.diffDate_TH(this.date);
          } else {
            this.date = "";
          }
          if (res.data.object.import_products_header.credit_date !== null) {
            this.dateDue = res.data.object.import_products_header.credit_date;
            this.diffDueDate_TH(this.dateDue);
          } else {
            this.dateDue = "";
          }

          this.product_list = res.data.object.import_products_edit_detail;
          res.data.object.import_products_edit_detail.forEach((data) => {
            console.log(data);
            const id = (this.loop_id += 1);
            this.data_list.push({
              loop_id: id,
              credit_status: data.credit_status,
              date_exp: data.date_expired,
              discount_unit_percent: data.discount_percent,
              discount_unit_price: data.discount_unit,
              id: data.id,
              lot_no: data.lot_no,
              po_id: this.$route.params.id,
              price: data.price,
              product_code: data.product_code,
              product_id: data.product_id,
              product_name: data.product_name,
              qty_received: data.quantity,
              status_complete: data.status_complete,
              status_return_old: 1,
              status_return: data.exchange_status,
              status_success: data.status_success,
              total: data.total,
              cost: data.cost,
              unit_id: data.unit_id,
              units: data.units,
              unit_name: data.name_unit,
            });
          });
        }

        this.loading_product = true;
        HTTP.post("/suppliers/getproducts", {
          supplier_id: this.header_list.supplier_id,
        }).then((res) => {
          if (res.data.success === true) {
            this.loading_product = false;
            this.product_list_supplier = res.data.object;
          }
        });
      });
    },
    async add_product(pro_id) {
      await HTTP.post("/imports/po/units", {
        product_id: pro_id,
      }).then((res) => {
        console.log(res);
        if (res.data.success === true) {
          this.alert_success = true;
          this.unit_list = res.data.object;
        }
      });

      let value = this.product_list_supplier.filter((res) => {
        return res.product_id === pro_id;
      });

      value.forEach((data) => {
        const id = (this.loop_id += 1);
        this.data_list.push({
          loop_id: id,
          credit_status: false,
          return_status: false,
          date_exp: this.date_table(this.min_date()),
          discount_unit_percent: null,
          discount_unit_price: null,
          id: null,
          lot_no: "",
          po_id: null,
          price: null,
          cost: 0,
          product_code: data.product_code,
          product_id: data.product_id,
          product_name: data.name,
          qty_received: null,
          total: 0,
          unit_id: data.unit_id,
          units: this.unit_list,
          unit_name: null,
          status_complete: false,
          status_return_old: 0,
          status_return: 0,
          status_success: false,
        });
      });
      await this.$nextTick(() => {
        this.pro_id = null;
        setTimeout(() => (this.alert_success = false), 3000);
      });
    },
    async update_po() {
      let check_date_expired = false;
      this.data_list.forEach(async(datalist, index) => {
        if (
          this.data_list[index].date_exp == null ||
          this.data_list[index].date_exp == ""
        ) {
          check_date_expired = true;
          return;
        }
      });
      if (this.$refs.update.validate()) {
        this.data_list.forEach(async(datalist, index) => {
          let item = datalist.units.find((detail) => {
            return detail.unit_id == datalist.unit_id;
          });
          this.data_list[index].sub_qty = item.unit_qty * datalist.qty_received;
          this.data_list[index].cost =
            datalist.total / (item.unit_qty * datalist.qty_received);
        });
        let duplicateIndices = [];
        this.data_list.forEach((element, index) => {
          // Find the index of the first occurrence of the current element
          const firstIndex = this.data_list.findIndex(
            (e, i) => i !== index && e.product_id === element.product_id
          );
          // If a duplicate is found
          if (firstIndex !== -1) {
            // Add both the current index and the first occurrence index to the duplicateIndices array
            duplicateIndices.push(element);
          }
        });
        // console.log(duplicateIndices);
        let qty_arr = [];
        let total_arr = [];
        let product_id = [];
        let checkcost = {};
        this.data_list.forEach(async (items) => {
          let item = null;
          let check_product_id = await product_id.find((o) => o == items.product_id)
            if (check_product_id == null) {
            total_arr.push({ id: items.product_id, total: 0 });
            qty_arr.push({ id: items.product_id, qty: 0 });
            product_id.push(items.product_id);
          }

          item = items.units.find((detail) => {
            return items.unit_id == detail.unit_id;
          });

           let qtyObj = qty_arr.find(o => o.id === items.product_id);
            if(qtyObj){
              qtyObj.qty += parseInt(items.qty_received * item.unit_qty)
            }
              let totalObj = total_arr.find(o => o.id === items.product_id);
            if(totalObj){
             totalObj.total += parseFloat(items.total)
            }
          checkcost = this.data_list.filter(
            (res) => res.product_id === items.product_id
          );
          checkcost.forEach((details) => {
            details.cost = totalObj.total / qtyObj.qty;
            console.log(details.cost)

          });
        });
        if (check_date_expired === true) {
          Swal.fire({
            title: "ไม่สามารถดำเนินการได้ !",
            text: "เนื่องจาก ไม่ได้กรอกวันหมดอายุของสินค้า !",
            icon: "error",
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          });
        }
        let data = {
            user_id: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
            po_code: this.product_list[0].po_code,
            supplier_name: this.product_list[0].supplier_name,
            import_product_id: this.product_list[0].import_product_id,
            discount_final: this.discount_final,
            product_no_vat: parseFloat(this.product_no_vat.replace(/,/g, "")),
            product_add_vat: parseFloat(this.product_add_vat.replace(/,/g, "")),
            discount_last_percent: this.header_list.discount_percent,
            discount_last_price: this.header_list.discount,
            grand_total: parseFloat(
              this.header_list.grand_total.replace(/,/g, "")
            ),
            po_date: this.diffDateEN(),
            credit_date: this.diffDueDateEN(),
            receipt_no: this.header_list.receipt_no,
            data_list: await this.data_list,
            type_vat: this.header_list.vat_type,
            is_credit: this.header_list.is_credit,
            note: this.header_list.note,
          }
        if (check_date_expired === false) {
          this.overlay = true;
          this.test = this.data_list
          HTTP.post('/imports/po/update', data).then((res) => {
            if (res.data.success === true) {
              this.overlay = false;
              Swal.fire("แก้ไขข้อมูลเรียบร้อย", "", "success").then(() => {
                this.$router.push("/stock/storage/addproducttostock");
              });
            }
          })
        }
      } else {
        Swal.fire({
          title: "ไม่สามารถดำเนินการได้ !",
          text: "เนื่องจาก ไม่มีข้อมูลหรือกรอกข้อมูลไม่ครบ !",
          icon: "error",
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        });
      }
    },
    getDelete(loop_id) {
      Swal.fire({
        text: "ต้องการลบข้อมูลหรือไม่ ?",
        icon: "warning",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.alert_danger = true;
          setTimeout(() => (this.alert_danger = false), 3000);
          this.data_list = this.data_list.filter(
            (detail) => detail.loop_id !== loop_id
          );
        }
      });
    },
  },
  computed: {
    total() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum, number) => {
      //   let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
      //   if (total_price < 0) {
      //     return sum+(0);
      //   }
      //   else {
      //     return sum+(total_price);
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        return sum + number.total;
      }, 0);
      return result
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    no_vat() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.header_list.type_vat === 0){
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
      //     let in_vat = ((total_price * 7)/107);
      //     let total_grand = total_price - in_vat
      //     if (total_grand < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+(total_grand);
      //     }
      //   }
      //   else if(this.header_list.type_vat === 1) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+((total_price));
      //     }
      //   }
      //   else if(this.header_list.type_vat === 2) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+((total_price));
      //     }
      //   }
      //   else if(this.header_list.type_vat === 3) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+((total_price));
      //     }
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      let discount_percent = this.header_list.discount_percent;
      let discount_unit = this.header_list.discount;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total;
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;

      if (this.header_list.vat_type == 0) {
        let before_vat = total_discount * (100 / 107);
        return before_vat
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return total_discount
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    cal_vat() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.header_list.type_vat === 0) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
      //     let calculate = ((total_price * 7)/107);
      //     return sum+(calculate);
      //   }
      //   else if (this.header_list.type_vat === 1){
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
      //     let calculate = (total_price * (7/100));
      //     return sum+(calculate);
      //   }
      //   else if (this.header_list.type_vat === 2){
      //     return sum+(0);
      //   }
      //   else if (this.header_list.type_vat === 3){
      //     return sum+(0);
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      let discount_percent = this.header_list.discount_percent;
      let discount_unit = this.header_list.discount;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total;
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;

      if (this.header_list.vat_type == 0) {
        let result_vat = total_discount * (7 / 107);
        return result_vat
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (this.header_list.vat_type == 1) {
        let result_vat = total_discount * (7 / 100);
        return result_vat
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        let zero = 0;
        return zero
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    total_all() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.header_list.type_vat === 0){
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price);
      //     }
      //   }
      //   else if(this.header_list.type_vat === 1) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
      //     let ex_vat = ((total_price * 7)/100);
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price + ex_vat);
      //     }
      //   }
      //   else if(this.header_list.type_vat === 2) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price);
      //     }
      //   }
      //   else if(this.header_list.type_vat === 3) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price);
      //     }
      //   }
      // }, 0)
      // return result;
      let result_vat = 0;
      let total_discount = 0;
      let discount_percent = this.header_list.discount_percent;
      let discount_unit = this.header_list.discount;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total;
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      if (this.header_list.vat_type == 1) {
        result_vat = total_percent - discount_unit;
        total_discount = result_vat * (7 / 100) + result_vat;
      } else {
        total_discount = total_percent - discount_unit;
      }

      return total_discount
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}

.border_col {
  border-left: #f1f1f1 solid 2px;
  border-right: #f1f1f1 solid 2px;
}

.grid_row {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}

.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_product {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_full {
  display: grid;
  grid-template-columns: 100%;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.v-input__slot {
  align-items: center !important;
  justify-content: center !important;
  padding-top: 10px !important;
}

.input_style >>> input {
  border: #9e9e9e solid 1px !important;
  transition: 0.2s !important;
  font-size: 18px !important;
  color: black !important;
  padding: 27px !important;
  padding-left: 12px !important;
}

.input_style >>> input:hover {
  border-color: black !important;
}

.input_style >>> input:focus {
  border-color: #8cc63e !important;
}

@media only screen and (max-width: 1100px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_product {
    display: grid;
    grid-template-columns: 100%;
  }
}

@media only screen and (max-width: 700px) {
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
